module.exports = __webpack_public_path__ + "img/4.3.4b44ff54.png";